/* the text below is for the overall description of the activities. This is v2 */
export const activitiesMainText = 
	{
		text: 'We provide personalized guidance for activities during your visit, from assisting with logistics for snow season or green season sports to recommending the best ways to explore local scenic spots and suggesting any local services you may need. Just ask us!',
		textJ: 'ご来訪の際には、スノーシーズンやグリーンシーズンのスポーツに関する手配から、周辺の観光名所の最適な巡り方のアドバイス、必要な地元のサービスのご提案まで、個別の案内を提供いたします。お気軽にお尋ねください！',
		textCh1: '我们为您的到访提供个性化的活动指导，从帮助您安排雪季或绿季的运动项目，到为您推荐最佳的景点游览路线，以及建议任何您可能需要的本地服务。请随时咨询我们！',
		textCh2: '我們為您的到訪提供個性化的活動指導，從幫助您安排雪季或綠季的運動項目，到為您推薦最佳的景點遊覽路線，以及建議任何您可能需要的本地服務。請隨時諮詢我們！'
	}